(function () {
  'use strict';

  var CFG = window.VB_CART_CFG || {};
  var root, cache = null, loadingUpsell = false;
  var TRASH = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2m2 0v12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7"/><path d="M10 11v6M14 11v6"/></svg>';

  function $(sel) { return root.querySelector(sel); }
  function money(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function open() { if (!root) return; root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; render(); }
  function close() { if (!root) return; root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

  async function getCart() { cache = await (await fetch('/cart.js', { cache: 'no-store' })).json(); return cache; }

  async function changeLine(key, qty) {
    await regEsperaTope(3000);                                              // que no se cruce con la puesta al día del regalo
    cache = await (await _fetch.call(window, '/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })).json();
    render();
  }

  function progressHTML(cart) {
    // Barra de hitos: envío gratis (siempre, desde 1 prenda) · t2 prendas −t2p% · t3 prendas −t3p%.
    // Los % los aplica Shopify vía descuentos automáticos; aquí solo se comunica el progreso real.
    var t2q = CFG.tier2Qty || 2, t2p = CFG.tier2Pct || 10;
    var t3q = CFG.tier3Qty || 3, t3p = CFG.tier3Pct || 15;
    var t4q = CFG.tier4Qty || 4, t4p = CFG.tier4Pct || 20;
    var q = regPrendas(cart);
    var t2Ok = q >= t2q, t3Ok = q >= t3q, t4Ok = q >= t4q;

    var msg;
    if (!t2Ok) {
      var f2 = t2q - q;
      msg = '🚚 <b>Envío gratis</b> en tu pedido · Añade ' + (f2 === 1 ? 'otra prenda' : f2 + ' prendas') + ' y llévate un <b>−' + t2p + '%</b>';
    } else if (!t3Ok) {
      var f3 = t3q - q;
      msg = '−' + t2p + '% conseguido · Añade ' + (f3 === 1 ? 'otra prenda' : f3 + ' prendas') + ' y sube al <b>−' + t3p + '%</b>';
    } else if (!t4Ok) {
      var f4 = t4q - q;
      msg = '−' + t3p + '% conseguido · Añade ' + (f4 === 1 ? 'otra prenda' : f4 + ' prendas') + ' y sube al <b>−' + t4p + '%</b>';
    } else {
      msg = '🎉 <b>Envío gratis</b> y <b>−' + t4p + '%</b> aplicados en tu pedido';
    }

    var fill;
    if (q < 1) fill = 0;
    else if (!t2Ok) fill = Math.min(50, 25 + q / t2q * 25);
    else if (!t3Ok) fill = Math.min(75, 50 + (q - t2q) / (t3q - t2q) * 25);
    else if (!t4Ok) fill = Math.min(99, 75 + (q - t3q) / (t4q - t3q) * 25);
    else fill = 100;

    function hito(left, ok, icon, label) {
      return '<span class="vb-cp__hito' + (ok ? ' done' : '') + '" style="left:' + left + '%"><i>' + icon + '</i><em>' + label + '</em></span>';
    }
    return '<div class="vb-cp" style="padding:0 0 16px">' +
      '<p class="vb-cp__msg">' + msg + '</p>' +
      '<div class="vb-cp__track"><span class="vb-cp__fill" style="width:' + fill + '%"></span>' +
      hito(25, q >= 1, '🚚', 'Envío gratis') +
      hito(50, t2Ok, '−' + t2p + '%', t2q + ' prendas') +
      hito(75, t3Ok, '−' + t3p + '%', t3q + ' prendas') +
      hito(100, t4Ok, '−' + t4p + '%', t4q + ' prendas') +
      '</div></div>';
  }

  function variantLine(it) {
    if (it.options_with_values && it.options_with_values.length) {
      return it.options_with_values
        .filter(function (o) { return o.value && o.value !== 'Default Title'; })
        .map(function (o) { return esc(o.name) + ': ' + esc(o.value); })
        .join(' · ');
    }
    return (it.variant_title && it.variant_title !== 'Default Title') ? esc(it.variant_title) : '';
  }

  // ── Línea de bienvenida en el pie (09/10/2026): «¿Primer pedido? Apúntate y llévate un 20 %» + nota con los dos casos (13/10). Cierra el carrito y abre la ventana propia
  // del tema (snippets/vb-vip-modal.liquid → window.vbVipAbrir). No sale si la clienta ya se apuntó o si la ventana no está en la página. ──
  var VIP_FRASE = CFG.vipFrase || '¿Primer pedido? <b style="color:#a3721c;font-weight:600">Apúntate y llévate un 20 %</b>';
  var VIP_NOTA = CFG.vipNota || '';   // 13/10: sin nota, solo el gancho (como la franja); las condiciones se explican en la ventana
  function paintVip() {
    if (!root) return;
    var foot = root.querySelector('[data-vb-foot]'), linea = root.querySelector('[data-vb-vip]'), suscrita = false;
    try { suscrita = localStorage.getItem('vb-vip-suscrita') === '1'; } catch (e) {}
    if (!foot || typeof window.vbVipAbrir !== 'function' || suscrita) { if (linea) linea.remove(); return; }
    if (linea) return;
    var b = document.createElement('button');
    b.type = 'button'; b.setAttribute('data-vb-vip', '');
    b.style.cssText = 'display:flex;align-items:center;justify-content:space-between;gap:10px;width:100%;margin:10px 0 4px;padding:10px 12px;background:#fdfbf6;border:1px solid rgba(184,153,90,.7);border-radius:6px;font-family:inherit;text-align:left;color:#1a1816;cursor:pointer';
    b.innerHTML = '<span style="font-size:13.5px;line-height:1.3">' + VIP_FRASE + (VIP_NOTA ? '<br><span style="font-size:11.5px;color:#8d867b">' + esc(VIP_NOTA) + '</span>' : '') + '</span>' +
      '<span style="flex:none;font-size:10px;letter-spacing:.18em;font-weight:600;border-bottom:1px solid #b8995a;padding-bottom:2px">LO QUIERO</span>';
    b.addEventListener('click', function () { close(); window.vbVipAbrir(); });
    var ancla = foot.querySelector('[data-vb-disc-msg]') || foot.querySelector('[data-vb-disc-form]') || foot.querySelector('[data-vb-disc-toggle]');
    if (ancla) ancla.insertAdjacentElement('afterend', b); else foot.insertBefore(b, foot.firstChild);
  }

  // ── Aviso de pocas unidades por artículo (09/10/2026): mismo interruptor que la ficha (metacampo stock.pocas_unidades).
  // Qué productos de la cesta lo tienen encendido lo dice sections/vb-cart-pocas.liquid (Section Rendering API). ──
  var POCAS_TXT = CFG.pocasText || 'Quedan pocas unidades · tu talla aún está disponible';
  var pocas = {}, pocasKey = null;
  function pocasHTML(it) {
    if (!pocas[it.product_id]) return '';
    return '<p class="vb-item__pocas" style="display:flex;align-items:flex-start;gap:8px;margin:8px 0 4px;font-size:13px;line-height:1.4;color:#a05c22;font-weight:500;letter-spacing:0;text-transform:none">' +
      '<span aria-hidden="true" style="flex-shrink:0;width:8px;height:8px;margin-top:5px;border-radius:50%;background:currentColor;box-shadow:0 0 0 3px rgba(207,127,61,.18)"></span>' +
      '<span>' + esc(POCAS_TXT) + '</span></p>';
  }
  function paintPocas() {
    if (!root || !cache) return;
    var els = root.querySelectorAll('[data-vb-items] .vb-item');
    Array.prototype.forEach.call(els, function (el) {
      var it = null;
      cache.items.forEach(function (x) { if (x.key === el.getAttribute('data-key')) it = x; });
      if (!it) return;
      var old = el.querySelector('.vb-item__pocas');
      if (old) old.remove();
      var html = pocasHTML(it), price = el.querySelector('.vb-item__price');
      if (html && price) price.insertAdjacentHTML('afterend', html);
    });
  }
  async function loadPocas(cart) {
    var key = cart.items.map(function (i) { return i.product_id; }).join(',');
    if (key === pocasKey) return;
    pocasKey = key;
    try {
      var html = await (await fetch('/?section_id=vb-cart-pocas&t=' + Date.now(), { cache: 'no-store' })).text();
      var m = html.match(/data-vb-cart-pocas="([^"]*)"/);
      if (!m) { pocasKey = null; return; }
      var next = {};
      m[1].split(',').forEach(function (id) { id = id.trim(); if (id) next[id] = true; });
      pocas = next;
    } catch (e) { pocasKey = null; return; }
    paintPocas();
  }

  // ── Regalo de calcetines (10/2026). Con N pares de un producto con la etiqueta «regalo-calcetines» van N−1 pares de calcetines de regalo
  // (tope 3). La clienta elige el color en la ficha (dentro del bloque del pack) o aquí, en el carrito. Desde el 10/10 el regalo va como
  // LÍNEA del pedido: el producto oculto «calcetines-de-regalo» (0 €, una variante por color), que este fichero pone y quita solo. No se
  // pinta como un artículo más sino como la tarjeta del regalo, y no cuenta como prenda (tampoco en el descuento por cantidad: Shopify no
  // cuenta las líneas a 0 €). El atributo «Calcetines de regalo» se mantiene como respaldo. Apagar: REG.activo = false. ──
  var REG = { activo: true, tag: 'regalo-calcetines', attr: 'Calcetines de regalo', prod: 'calcetines-de-regalo', foto: 'https://cdn.shopify.com/s/files/1/1027/9213/4990/files/regalo_calcetines.jpg?v=1791581346',
    colores: [['Crema', '#f0e8d2', 61151294521678], ['Beige', '#c8b79f', 61151294554446], ['Marrón', '#7a4f38', 61151294587214], ['Negro', '#1d1b1a', 61151294619982]] };
  var ICO_REG = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" style="flex:none"><path d="M20 12v9H4v-9M2 7h20v5H2zM12 22V7M12 7H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 1 0 0-5C13 2 12 7 12 7z"/></svg>';
  var regTag = {}, regSeq = 0, regPend = null, regEnviando = false, regOtra = false, regFallos = 0;
  function esRegalo(it) { return !!it && it.handle === REG.prod; }
  function regPrendas(cart) { var n = 0; ((cart && cart.items) || []).forEach(function (it) { if (!esRegalo(it)) n += it.quantity; }); return n; }
  function regVisibles(cart) { return ((cart && cart.items) || []).filter(function (it) { return !esRegalo(it); }); }
  // La cabecera pinta el número con Liquid (cart.item_count, que sí cuenta los calcetines): se corrige aquí, sin tocar ese fichero.
  function regCabecera(n) {
    if (!(n > 0)) return;
    Array.prototype.forEach.call(document.querySelectorAll('.mlx-count, .vhd-cart-count'), function (e) { if (e.textContent.trim() !== String(n)) e.textContent = n; });
  }
  // Página /cart: la pinta el tema con Liquid, que sí cuenta los calcetines. Se corrigen la barra de progreso y el contador, y la fila
  // del regalo se queda sin botones de cantidad (el regalo se pone y se quita solo). Solo actúa si hay calcetines en el carrito.
  function regPagina(cart) {
    if (!cart || !/^\/cart\/?$/.test(location.pathname) || !(cart.items || []).some(esRegalo)) return;
    var n = regPrendas(cart), pr = document.getElementById('vb-cart-progress'), t = document.createElement('div');
    if (pr) { t.innerHTML = progressHTML(cart); if (t.firstChild) { pr.innerHTML = t.firstChild.innerHTML; pr.setAttribute('data-qty', n); } }
    Array.prototype.forEach.call(document.querySelectorAll('.cart-title .cart-bubble__text-count'), function (e) { if (n > 0 && e.textContent.trim() !== String(n)) e.textContent = n; });
    Array.prototype.forEach.call(document.querySelectorAll('.cart-items__table-row'), function (f) {
      var a = f.querySelector('a.cart-items__title'), c = f.querySelector('.cart-items__quantity-controls');
      if (a && c && (a.getAttribute('href') || '').indexOf('/products/' + REG.prod) >= 0) c.style.visibility = 'hidden';
    });
  }
  function regFoto(w) { return REG.foto + (REG.foto.indexOf('?') < 0 ? '?' : '&') + 'width=' + w; }
  function regCuantos(pares) { return pares >= 2 ? Math.min(pares - 1, 3) : 0; }     // un par de calcetines menos que de botas; tope 3
  function regTitulo(n) { return n > 1 ? n + ' pares de calcetines de regalo' : 'Calcetines de regalo'; }
  function regColor(i) {
    var c = []; try { c = JSON.parse(localStorage.getItem('vb-regalo-colores') || '[]') || []; } catch (e) {}
    return REG.colores.some(function (x) { return x[0] === c[i]; }) ? c[i] : REG.colores[0][0];
  }
  function regGuarda(i, nombre) { var c = [regColor(0), regColor(1), regColor(2)]; c[i] = nombre; try { localStorage.setItem('vb-regalo-colores', JSON.stringify(c)); } catch (e) {} }
  function regFilas(n, t) {
    var h = '';
    for (var i = 0; i < n; i++) {
      h += '<span style="display:block;margin-top:' + (i ? 10 : 6) + 'px;font-size:12.5px;line-height:1.3;color:#5c554b;font-weight:400;letter-spacing:0;text-transform:none">' + (n > 1 ? 'Par ' + (i + 1) + ': ' : 'Color: ') + '<b style="color:#1a1816">' + esc(regColor(i)) + '</b></span>' +
        '<span style="display:flex;gap:11px;align-items:center;margin-top:7px">' + REG.colores.map(function (x) {
          var on = x[0] === regColor(i);
          return '<button type="button" data-reg-color="' + esc(x[0]) + '" data-reg-i="' + i + '" title="' + esc(x[0]) + '" aria-label="' + esc(x[0]) + '" aria-pressed="' + on + '" style="flex:none;box-sizing:border-box;width:' + t + 'px;height:' + t + 'px;min-width:0;min-height:0;padding:0;margin:0;line-height:0;-webkit-appearance:none;appearance:none;border-radius:50%;background:' + x[1] + ';border:1px solid rgba(26,24,22,.22);cursor:pointer;' + (on ? 'box-shadow:0 0 0 2px #fff,0 0 0 3.5px #1a1816;' : '') + '"></button>';
        }).join('') + '</span>';
    }
    return h;
  }
  // ¿El producto da derecho a regalo? Se lee de sus etiquetas y se recuerda durante la visita. Si falla la red LANZA el error, para que
  // quien llama no toque el regalo (un fallo no puede dejar a la clienta sin sus calcetines).
  async function regElegible(handle) {
    if (regTag[handle] === undefined) {
      var k = 'vb-reg-tag:' + handle, v = null;
      try { v = sessionStorage.getItem(k); } catch (e) {}
      if (v === '1' || v === '0') regTag[handle] = v === '1';
      else {
        var p;
        try { p = await loadProduct(handle); } catch (e) { delete prodCache[handle]; throw e; }
        regTag[handle] = (p.tags || []).indexOf(REG.tag) >= 0;
        try { sessionStorage.setItem(k, regTag[handle] ? '1' : '0'); } catch (e) {}
      }
    }
    return regTag[handle];
  }
  function regVariante(nombre) { for (var i = 0; i < REG.colores.length; i++) if (REG.colores[i][0] === nombre) return REG.colores[i][2]; return REG.colores[0][2]; }
  function regEspera() { return regPend ? regPend.then(regEspera) : Promise.resolve(); }
  // Lo mismo, pero sin esperar más de «ms»: nada del carrito se queda colgado por una puesta al día lenta.
  function regEsperaTope(ms) { return Promise.race([regEspera(), new Promise(function (ok) { setTimeout(ok, ms); })]); }
  // En la página /cart las líneas las pinta el tema: si el regalo ha cambiado, se recarga (como mucho dos veces seguidas).
  function regRecarga() {
    if (!/^\/cart\/?$/.test(location.pathname)) return;
    try {
      var a = JSON.parse(sessionStorage.getItem('vb-reg-recarga') || '[]').filter(function (t) { return Date.now() - t < 15000; });
      if (a.length >= 2) return;
      a.push(Date.now()); sessionStorage.setItem('vb-reg-recarga', JSON.stringify(a));
    } catch (e) { return; }
    location.reload();
  }
  // Deja en el carrito las líneas de regalo que tocan (n pares, con los colores elegidos) y el atributo de respaldo. Las cantidades que
  // se envían son absolutas, así que repetir la llamada no duplica nada.
  async function regLineas(cart, n) {
    var quiero = {}, tengo = {}, up = {}, hay = false, k, i, cuerpo = {};
    for (i = 0; i < n; i++) { k = regVariante(regColor(i)); quiero[k] = (quiero[k] || 0) + 1; }
    (cart.items || []).forEach(function (it) { if (esRegalo(it)) tengo[it.variant_id] = (tengo[it.variant_id] || 0) + it.quantity; });
    for (k in quiero) if (quiero[k] !== (tengo[k] || 0)) { up[k] = quiero[k]; hay = true; }
    for (k in tengo) if (!quiero[k]) { up[k] = 0; hay = true; }
    var nota = [0, 1, 2].slice(0, n).map(regColor).join(' + '), a = {}; a[REG.attr] = nota;
    if (hay) cuerpo.updates = up;
    if (nota !== ((cart.attributes || {})[REG.attr] || '')) cuerpo.attributes = a;
    if (!cuerpo.updates && !cuerpo.attributes) { regFallos = 0; return; }
    if (regFallos >= 3) return;                                       // la tienda no lo acepta: no insistir en esta página
    if (regEnviando) { regOtra = true; return; }                      // ya hay una en marcha: al acabar se repasa
    regEnviando = true; regFallos++;
    var post = function (b) { return _fetch.call(window, '/cart/update.js', { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(b) }); };
    try {
      var r = await post(cuerpo);
      if (!r.ok) throw new Error('regalo ' + r.status);
      try { await r.text(); } catch (e) {}                              // se lee la respuesta para que la petición quede cerrada
      var otra = regOtra; regEnviando = false; regOtra = false;
      if (hay) { await getCart(); render(); regRecarga(); }             // render() vuelve a pasar por aquí y repasa lo que falte
      else { cart.attributes = cart.attributes || {}; cart.attributes[REG.attr] = nota; if (otra) paintRegalo(cache, !(root && root.classList.contains('is-open'))); }
    } catch (e) {
      regEnviando = false; regOtra = false;
      if (hay) post({ attributes: a }).then(function (x) { return x.text(); }).catch(function () {});          // que al menos quede anotado el color en el pedido
    }
  }
  async function regalo(cart, soloLineas) {
    if (!cart || !cart.items) return;
    var seq = ++regSeq, pares = 0;
    for (var k = 0; k < cart.items.length; k++) { if (!esRegalo(cart.items[k]) && await regElegible(cart.items[k].handle)) pares += cart.items[k].quantity; }
    if (seq !== regSeq) return;                                    // el carrito cambió mientras se consultaba
    var n = REG.activo ? regCuantos(pares) : 0;
    if (root && !soloLineas) {
      var viejo = root.querySelector('[data-vb-regalo]'), items = root.querySelector('[data-vb-items]'), msg = root.querySelector('.vb-cp__msg');
      if (viejo) viejo.remove();
      if (REG.activo && pares === 1 && msg && !msg.querySelector('[data-reg-aviso]')) msg.insertAdjacentHTML('beforeend', '<span data-reg-aviso> · Con otro par de botas, <b>calcetines de regalo</b></span>');
      if (n && items) {
        var d = document.createElement('div'); d.setAttribute('data-vb-regalo', '');
        d.style.cssText = 'display:flex;align-items:center;gap:12px;margin:14px 0 0;padding:12px 14px;border:1px dashed rgba(184,153,90,.9);border-radius:8px;background:#fdfbf6;color:#1a1816';
        d.innerHTML = '<img src="' + esc(regFoto(160)) + '" alt="" width="66" height="66" loading="lazy" style="width:66px;height:66px;border-radius:6px;object-fit:cover;flex:none">' +
          '<span style="flex:1;min-width:0;font-size:14px;line-height:1.3"><b>' + regTitulo(n) + '</b>' + regFilas(n, 22) + '</span>' +
          '<span style="flex:none;font-size:14px;font-weight:600;color:#2e7d32">GRATIS</span>';
        d.addEventListener('click', function (e) { var b = e.target.closest('[data-reg-color]'); if (!b) return; regGuarda(+b.getAttribute('data-reg-i'), b.getAttribute('data-reg-color')); paintRegalo(cache); });
        items.appendChild(d);
      }
    }
    await regLineas(cart, n);
  }
  // regPend = lo que está en marcha: «Finalizar compra» y los cambios de cantidad esperan a que acabe.
  function paintRegalo(cart, soloLineas) {
    var p = regalo(cart, soloLineas).catch(function () {}).then(function () { if (regPend === p) regPend = null; });
    regPend = p; return p;
  }
  async function initRegaloFicha() {
    var bv = document.querySelector('.vb-bv'), m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!REG.activo || !bv || !m) return;
    try { if (!(await regElegible(decodeURIComponent(m[1])))) return; } catch (e) { return; }
    function pinta() {
      Array.prototype.forEach.call(bv.querySelectorAll('.vb-bv__op'), function (op) {
        var n = regCuantos(+op.getAttribute('data-n')), old = op.querySelector('[data-reg-ficha]');
        if (old) old.remove();
        if (!n) return;
        var d = document.createElement('div'); d.setAttribute('data-reg-ficha', '');
        if (op.classList.contains('is-on')) {
          d.style.cssText = 'display:flex;align-items:center;gap:13px;margin:2px 14px 14px;padding:11px 12px;border:1px dashed rgba(184,153,90,.9);border-radius:8px;background:#fdfbf6';
          d.innerHTML = '<img src="' + esc(regFoto(200)) + '" alt="Calcetines de canalé en varios colores" width="74" height="74" loading="lazy" style="width:74px;height:74px;border-radius:6px;object-fit:cover;flex:none">' +
            '<span style="flex:1;min-width:0"><span style="display:flex;align-items:center;gap:6px;font-size:12px;letter-spacing:.08em;font-weight:600;color:#a3721c;text-transform:uppercase">' + ICO_REG + '<span>' + regTitulo(n) + '</span></span>' + regFilas(n, 24) + '</span>';
        } else {
          d.style.cssText = 'display:flex;align-items:center;gap:7px;padding:0 16px 13px 52px;margin-top:-4px;font-size:12px;letter-spacing:.08em;font-weight:600;color:#a3721c;text-transform:uppercase';
          d.innerHTML = ICO_REG + '<span>+ ' + regTitulo(n) + '</span>';
        }
        op.appendChild(d);
      });
    }
    pinta();
    bv.addEventListener('click', function (e) {
      var b = e.target.closest('[data-reg-color]');
      if (b) { e.preventDefault(); regGuarda(+b.getAttribute('data-reg-i'), b.getAttribute('data-reg-color')); pinta(); if (cache) paintRegalo(cache); return; }
      if (e.target.closest('.vb-bv__cab')) setTimeout(pinta, 0);
    });
  }

  function itemHTML(it) {
    var variant = variantLine(it);
    var savePer = it.line_level_total_discount > 0 ? Math.round(it.line_level_total_discount / it.quantity) : 0;
    var saved = savePer > 0 ? '<span class="vb-item__save">Ahorra ' + money(savePer) + '</span>' : '';
    var cmp = it.original_price > it.final_price ? '<span class="vb-item__price--cmp">' + money(it.original_price) + '</span>' : '';
    var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
    return '<div class="vb-item" data-key="' + esc(it.key) + '" data-handle="' + esc(it.handle) + '">' +
      '<img class="vb-item__img" src="' + esc(img) + '" alt="" loading="lazy">' +
      '<div class="vb-item__info">' +
        '<p class="vb-item__name">' + esc(it.product_title || it.title.split(' - ')[0]) + '</p>' +
        (variant ? '<p class="vb-item__variant">' + variant + '</p>' : '') +
        '<p class="vb-item__price"><span class="vb-item__price--sale">' + money(it.final_price) + '</span>' + cmp + saved + '</p>' +
        pocasHTML(it) +
        '<div class="vb-item__ctrl">' +
          '<span class="vb-item__qty"><button data-dec aria-label="Restar">−</button><span>' + it.quantity + '</span><button data-inc aria-label="Sumar">+</button></span>' +
          '<button class="vb-item__rm" data-rm aria-label="Quitar">' + TRASH + '</button>' +
        '</div>' +
        extraHTML(it) +
      '</div>' +
    '</div>';
  }

  function render() {
    if (!root || !cache) return;
    var cart = cache;
    var prendas = regPrendas(cart);
    $('[data-vb-count]').textContent = prendas;
    regCabecera(prendas);
    $('[data-vb-progress]').innerHTML = progressHTML(cart);

    var empty = prendas === 0;
    $('[data-vb-empty]').hidden = !empty;
    $('[data-vb-foot]').hidden = empty;
    $('[data-vb-body]').style.display = empty ? 'none' : '';
    $('[data-vb-progress]').style.display = empty ? 'none' : '';
    if (empty) { $('[data-vb-upsell]').hidden = true; if (cart.item_count) paintRegalo(cart, true); return; }   // solo quedan calcetines: se quitan

    $('[data-vb-items]').innerHTML = regVisibles(cart).map(itemHTML).join('');
    $('[data-vb-subtotal]').textContent = money(cart.original_total_price);
    var disc = cart.total_discount;
    $('[data-vb-disc-row]').hidden = disc <= 0;
    $('[data-vb-disc]').textContent = '−' + money(disc);
    $('[data-vb-total]').textContent = money(cart.total_price);
    $('[data-vb-cta-total]').textContent = money(cart.total_price);

    bindItems();
    loadPocas(cart);
    paintVip();
    paintRegalo(cart);
    loadUpsell(cart);
    tickTimer();
  }

  // ── Otra talla/color + tabla de tallas por artículo (Varela, 04/09, v2 premium) ──
  var prodCache = {}, sgCache = {};
  var ICO_PLUS = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>';
  var ICO_RULER = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M3 17L17 3l4 4L7 21zM8 16l1.5-1.5M11 13l1.5-1.5M14 10l1.5-1.5"/></svg>';
  function extraHTML(it) {
    var links = '';
    if (CFG.otraTalla !== false) links += '<button type="button" class="vb-item__link" data-otra>' + ICO_PLUS + '<span>Otra talla o color</span></button>';
    if (CFG.tablaTallas !== false) links += '<button type="button" class="vb-item__link" data-sg>' + ICO_RULER + '<span>Tabla de tallas</span></button>';
    if (!links) return '';
    return '<div class="vb-item__extra">' + links +
      '<div class="vb-item__panel" data-otra-panel hidden></div>' +
      '<div class="vb-item__panel vb-item__sg" data-sg-panel hidden></div>' +
    '</div>';
  }
  async function loadProduct(handle) {
    if (!prodCache[handle]) prodCache[handle] = (await fetch('/products/' + handle + '.js')).json();
    return prodCache[handle];
  }
  // Una sola descarga de la ficha por producto: de ahi salen la tabla de tallas y la familia de colores
  // (el <script data-vb-familia> que publica blocks/varela-variant-picker.liquid).
  async function loadPage(handle) {
    if (!sgCache[handle]) {
      sgCache[handle] = (async function () {
        try {
          var html = await (await fetch('/products/' + handle)).text();
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var body = doc.querySelector('.vb-sg-body');
          var famEl = doc.querySelector('script[data-vb-familia]');
          var fam = null;
          if (famEl) { try { fam = JSON.parse(famEl.textContent); } catch (e) { fam = null; } }
          return { sg: body ? body.innerHTML : '', fam: fam };
        } catch (e) { delete sgCache[handle]; return { sg: '', fam: null }; }   // no cachear el fallo: reintentar
      })();
    }
    return sgCache[handle];
  }
  function thumb(src) { return src ? src.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : ''; }
  function optNames(prod) {
    return (prod.options || []).map(function (o) { return (o && typeof o === 'object') ? (o.name || '') : String(o); });
  }
  function idxTalla(prod) {
    var n = optNames(prod);
    for (var i = 0; i < n.length; i++) if (/talla|size/i.test(n[i])) return i;
    return -1;
  }
  // En Varela cada color es un PRODUCTO distinto, asi que la opcion "Color" de una ficha trae un unico valor:
  // pintarla no aportaba nada (el fallo que vio Adria el 18/09). Las filas de un solo valor ya no se pintan y
  // los demas colores salen de la familia (la coleccion hermana que publica la ficha), de modo que se puede
  // cambiar de color sin salir del carrito.
  function buildOtra(po, item, prod, fam) {
    var cur = prod;
    var chosen = optNames(prod).map(function (_, i) { var c = (item.options_with_values || [])[i]; return c ? c.value : null; });
    function values(i) { var vs = []; cur.variants.forEach(function (v) { var val = v['option' + (i + 1)]; if (vs.indexOf(val) < 0) vs.push(val); }); return vs; }
    function variantFor(sel) { return cur.variants.find(function (v) { return sel.every(function (val, i) { return val == null || v['option' + (i + 1)] === val; }); }); }
    function esColor(name) { return /color|colour/i.test(name); }
    // foto de un color = la primera variante de ese color que tenga foto propia (la talla S a veces no tiene)
    function fotoDe(i, val) {
      var v = cur.variants.find(function (x) { return x['option' + (i + 1)] === val && x.featured_image; });
      return v ? v.featured_image.src : '';
    }
    // solo se pinta con fotos si TODOS los colores tienen la suya y son distintas entre si
    function conFotos(i, vs) {
      var fotos = vs.map(function (val) { return fotoDe(i, val); });
      if (fotos.some(function (f) { return !f; })) return null;
      for (var a = 0; a < fotos.length; a++) for (var b = a + 1; b < fotos.length; b++) if (fotos[a] === fotos[b]) return null;
      return fotos;
    }
    async function cambiarColor(handle) {
      if (!handle || handle === cur.handle) return;
      var it = idxTalla(cur), talla = it >= 0 ? chosen[it] : null;
      var previo = cur;
      po.innerHTML = '<p class="vb-item__hint">Cargando\u2026</p>';
      try {
        cur = await loadProduct(handle);
      } catch (e) {
        // el color ya no esta en la tienda (404) o se ha caido la red: no dejar el panel colgado
        delete prodCache[handle];
        cur = previo;
        if (fam && fam.items) fam = { titulo: fam.titulo, items: fam.items.filter(function (x) { return x.handle !== handle; }) };
        draw();
        var avisoEl = document.createElement('p');
        avisoEl.className = 'vb-item__hint';
        avisoEl.textContent = 'Ese color ya no est\u00e1 disponible.';
        po.insertBefore(avisoEl, po.firstChild);
        return;
      }
      var nt = idxTalla(cur);
      chosen = optNames(cur).map(function (_, i) {
        var vs = values(i);
        if (i === nt) return (talla && vs.indexOf(talla) >= 0) ? talla : null;
        return vs.length === 1 ? vs[0] : null;
      });
      draw();
    }
    function draw() {
      var html = '';
      if (fam && fam.items && fam.items.length > 1) {
        var act = fam.items.filter(function (x) { return x.handle === cur.handle; })[0];
        html += '<div class="vb-otra__row"><span class="vb-otra__label">' + esc(fam.titulo || 'Color') + '<em>' + esc(act ? act.nombre : '') + '</em></span><div class="vb-otra__chips vb-otra__fam">';
        fam.items.forEach(function (sib) {
          html += '<button type="button" class="vb-chip vb-chip--img' + (sib.handle === cur.handle ? ' is-sel' : '') + '"' +
            ' data-fam="' + esc(sib.handle) + '" title="' + esc(sib.titulo) + '" aria-label="' + esc(sib.nombre) + '">' +
            '<img src="' + esc(thumb(sib.img)) + '" alt="' + esc(sib.nombre) + '" loading="lazy"></button>';
        });
        html += '</div></div>';
      }
      optNames(cur).forEach(function (name, i) {
        var vs = values(i);
        if (vs.length < 2) return;
        var fotos = esColor(name) ? conFotos(i, vs) : null;
        html += '<div class="vb-otra__row"><span class="vb-otra__label">' + esc(name) + '<em data-cur="' + i + '">' + esc(chosen[i] || '') + '</em></span><div class="vb-otra__chips">';
        vs.forEach(function (val, j) {
          var probe = chosen.slice(); probe[i] = val;
          var v = variantFor(probe); var off = !(v && v.available);
          html += '<button type="button" class="vb-chip' + (fotos ? ' vb-chip--img' : '') + (chosen[i] === val ? ' is-sel' : '') + (off ? ' is-off' : '') +
            '" data-opt="' + i + '" data-val="' + esc(val) + '" title="' + esc(val) + '" aria-label="' + esc(val) + '">' +
            (fotos ? '<img src="' + esc(thumb(fotos[j])) + '" alt="' + esc(val) + '" loading="lazy">' : esc(val)) + '</button>';
        });
        html += '</div></div>';
      });
      if (!html) html += '<p class="vb-item__hint">Este art\u00edculo no tiene m\u00e1s tallas ni colores.</p>';
      var falta = chosen.some(function (c, i) { return c == null && values(i).length > 1; });
      var v = variantFor(chosen), ok = !falta && v && v.available;
      html += '<button type="button" class="vb-otra__add" data-add' + (ok ? '' : ' disabled') + '>' +
        (falta ? 'Elige tu talla' : (ok ? 'A\u00f1adir al carrito \u00b7 ' + money(v.price) : 'Combinaci\u00f3n no disponible')) + '</button>';
      po.innerHTML = html;
      po.querySelectorAll('.vb-chip[data-opt]').forEach(function (b) {
        b.onclick = function () { chosen[+b.dataset.opt] = b.dataset.val; draw(); };
      });
      po.querySelectorAll('.vb-chip[data-fam]').forEach(function (b) {
        b.onclick = function () { cambiarColor(b.dataset.fam); };
      });
      // la fila de colores va en horizontal: se centra el que la clienta ya tiene en el carrito
      var tira = po.querySelector('.vb-otra__fam'), sel = tira && tira.querySelector('.is-sel');
      if (tira && sel) tira.scrollLeft = sel.offsetLeft - (tira.clientWidth / 2) + (sel.offsetWidth / 2);
      var add = po.querySelector('[data-add]');
      add.onclick = async function () {
        var vv = variantFor(chosen); if (!vv || !vv.available) return;
        add.disabled = true; add.textContent = 'A\u00f1adiendo\u2026';
        try {
          await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: vv.id, quantity: 1 }) });
          add.textContent = 'A\u00f1adido \u2713'; add.classList.add('is-ok');
          // el interceptor de fetch del cajon ya recarga el carrito y repinta; no hace falta repetirlo aqui
        } catch (e) { add.disabled = false; add.textContent = 'No se ha podido a\u00f1adir'; }
      };
    }
    draw();
  }

  function bindExtra(row, item) {
    var bo = row.querySelector('[data-otra]'), po = row.querySelector('[data-otra-panel]');
    var bs = row.querySelector('[data-sg]'), ps = row.querySelector('[data-sg-panel]');
    function toggle(btn, panel, other, otherBtn, loader) {
      btn.onclick = async function () {
        var opening = panel.hidden;
        if (other) { other.hidden = true; if (otherBtn) otherBtn.classList.remove('is-open'); }
        panel.hidden = !opening; btn.classList.toggle('is-open', opening);
        if (opening && !panel.dataset.ready) {
          panel.innerHTML = '<p class="vb-item__hint">Cargando…</p>';
          try { await loader(); panel.dataset.ready = '1'; }
          catch (e) { panel.innerHTML = '<p class="vb-item__hint">No se ha podido cargar. Inténtalo de nuevo.</p>'; }
        }
      };
    }
    if (bo && po) toggle(bo, po, ps, bs, async function () {
      var prod = await loadProduct(item.handle);
      var fam = (await loadPage(item.handle)).fam;
      buildOtra(po, item, prod, fam);
    });
    if (bs && ps) toggle(bs, ps, po, bo, async function () {
      var sg = (await loadPage(item.handle)).sg;
      ps.innerHTML = sg || '<p class="vb-item__hint">Consulta la tabla de tallas en la ficha del producto.</p>';
    });
  }

  function bindItems() {
    root.querySelectorAll('.vb-item').forEach(function (row) {
      var key = row.dataset.key;
      var item = cache.items.find(function (i) { return i.key === key; });
      if (!item) return;
      row.querySelector('[data-inc]').onclick = function () { changeLine(key, item.quantity + 1); };
      row.querySelector('[data-dec]').onclick = function () { changeLine(key, item.quantity - 1); };
      row.querySelector('[data-rm]').onclick = function () { changeLine(key, 0); };
      bindExtra(row, item);
    });
  }

  async function loadUpsell(cart) {
    var box = $('[data-vb-upsell]');
    if (CFG.upsellShow === false) { box.hidden = true; return; }
    var seedItem = regVisibles(cart)[0];
    if (!seedItem) { box.hidden = true; return; }
    if (loadingUpsell) return; loadingUpsell = true;
    var inCart = cart.items.map(function (i) { return i.product_id; });
    // Género de la prenda semilla: por tags (fiable; algunos productos de hombre
    // no llevan "hombre" en el handle, p. ej. Adrián). cart.js no trae tags → se pide el producto.
    var seedTags = '';
    try { var sd = await (await fetch('/products/' + seedItem.handle + '.js')).json(); seedTags = (sd.tags || []).join(' '); } catch (e) {}
    var hay = (seedItem.handle || '') + ' ' + (seedItem.product_title || '') + ' ' + seedTags;
    var gender = /hombre/i.test(hay) ? 'hombre' : 'mujer';
    try {
      var data = await (await fetch('/recommendations/products.json?product_id=' + seedItem.product_id + '&intent=related&limit=12')).json();
      var matches = (data.products || []).filter(function (p) {
        if (inCart.indexOf(p.id) !== -1) return false;
        // 13/10/2026 · prueba de precio (duplicado de Catalina a 44,99 €): ni el «gemelo» de la prenda semilla (mismo nombre antes de « | ») ni productos con la etiqueta «oculto»
        if ((p.tags || []).indexOf('oculto') !== -1) return false;
        if (String(p.title || '').split(' | ')[0] === String(seedItem.product_title || '').split(' | ')[0]) return false;
        var isH = (p.tags || []).some(function (t) { return /hombre/i.test(t); }) || /hombre/i.test((p.handle || '') + ' ' + (p.type || ''));
        return gender === 'hombre' ? isH : !isH;
      }).slice(0, 6);
      var track = $('[data-vb-upsell-track]');
      track.innerHTML = matches.map(function (p) {
        var v = p.variants[0];
        var opts = p.variants.map(function (x) { return '<option value="' + x.id + '"' + (x.available ? '' : ' disabled') + '>' + esc(x.title) + '</option>'; }).join('');
        var img = p.featured_image || (p.images && p.images[0]) || '';
        var cmp = (v.compare_at_price && v.compare_at_price > v.price) ? '<span class="c">' + money(v.compare_at_price) + '</span>' : '';
        return '<div class="vb-up__card">' +
          '<img class="vb-up__img" src="' + esc(img) + '" alt="" loading="lazy">' +
          '<div class="vb-up__info">' +
            '<p class="vb-up__name">' + esc(p.title.split(' | ')[0]) + '</p>' +
            '<p class="vb-up__price"><span class="s">' + money(v.price) + '</span>' + cmp + '</p>' +
            '<div class="vb-up__row">' +
              (p.variants.length > 1 ? '<select>' + opts + '</select>' : '') +
              '<button data-add data-single="' + v.id + '" type="button">Añadir</button>' +
            '</div>' +
          '</div>' +
        '</div>';
      }).join('');
      box.hidden = matches.length === 0;
      // Flechas del carrusel
      var prev = root.querySelector('[data-vb-up-prev]');
      var next = root.querySelector('[data-vb-up-next]');
      function scrollByCard(dir) {
        var card = track.querySelector('.vb-up__card');
        var w = card ? card.getBoundingClientRect().width + 12 : 220;
        track.scrollBy({ left: dir * w, behavior: 'smooth' });
      }
      var single = matches.length <= 1;
      if (prev) { prev.hidden = single; prev.onclick = function () { scrollByCard(-1); }; }
      if (next) { next.hidden = single; next.onclick = function () { scrollByCard(1); }; }
      Array.prototype.slice.call(track.querySelectorAll('.vb-up__card')).forEach(function (card, i) {
        var p = matches[i];
        var sel = card.querySelector('select');
        var img = card.querySelector('.vb-up__img');
        var addBtn = card.querySelector('[data-add]');
        // Cambiar la miniatura al elegir variante
        if (sel && img && p) {
          sel.addEventListener('change', function () {
            var v = (p.variants || []).filter(function (x) { return String(x.id) === sel.value; })[0];
            var fi = v && v.featured_image;
            var src = (fi && fi.src) ? fi.src : (typeof fi === 'string' ? fi : (p.featured_image || (p.images && p.images[0])));
            if (src) img.src = src;
          });
        }
        if (addBtn) {
          addBtn.onclick = async function () {
            var id = sel ? parseInt(sel.value, 10) : parseInt(addBtn.dataset.single, 10);
            addBtn.disabled = true; addBtn.textContent = 'Añadiendo…';
            await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: id, quantity: 1 }) });
            await getCart(); render();
          };
        }
      });
    } catch (e) { box.hidden = true; }
    loadingUpsell = false;
  }

  // ── Temporizador de reserva (urgencia) ──
  var TIMER_MIN = CFG.timerMin || 10;
  var TIMER_SHOW = CFG.timerShow !== false;
  var TIMER_TPL = CFG.timerText || 'Tu carrito está reservado durante {t}';
  function tickTimer() {
    if (!root) return;
    var el = root.querySelector('[data-vb-timer]');
    if (!el) return;
    var hasItems = cache && cache.item_count > 0;
    if (!hasItems || !TIMER_SHOW) { el.hidden = true; return; }
    var dl = parseInt(sessionStorage.getItem('vb_cart_deadline') || '0', 10);
    var now = Date.now();
    if (!dl || dl < now) { dl = now + TIMER_MIN * 60000; sessionStorage.setItem('vb_cart_deadline', String(dl)); }
    var rem = Math.max(0, dl - now);
    var m = Math.floor(rem / 60000);
    var s = Math.floor((rem % 60000) / 1000);
    var clock = m + ':' + (s < 10 ? '0' : '') + s;
    el.querySelector('[data-vb-timer-text]').textContent = TIMER_TPL.replace('{t}', clock);
    el.hidden = false;
  }
  setInterval(tickTimer, 1000);

  // ── Apertura: icono del carrito (móvil + desktop) ──
  function isCartTrigger(el) {
    var a = el.closest('a[href$="/cart"], a[href="/cart"], a[href*="/cart?"], a[href*="/cart#"], cart-icon, [data-testid="cart-icon"], [data-testid="cart-drawer-trigger"], .cart-bubble, .cart-drawer__trigger, #cart-icon-bubble, [aria-label="Carrito"], [aria-label="Cart"], [aria-label="Cesta"]');
    if (!a || a.closest('#vb-drawer')) return false;
    // No disparar con el botón de menú/hamburguesa ni búsqueda
    if (a.matches('.vhd-hamburger, [aria-label="Menú"], [aria-label="Menu"], [aria-label="Buscar"], [aria-label="Search"]')) return false;
    return true;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-vb-close]')) { e.preventDefault(); close(); return; }
    if (isCartTrigger(t)) { e.preventDefault(); e.stopImmediatePropagation(); open(); return; }
    var co = t.closest('[data-vb-checkout]');
    if (co && regPend && !co.hasAttribute('data-reg-ir')) {
      e.preventDefault(); co.setAttribute('data-reg-ir', '');
      var ir = function () { if (!ir.ya) { ir.ya = true; location.href = co.href; } };
      regEspera().then(ir); setTimeout(ir, 2500);
    }
  }, true);

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  // ── Auto-abrir al añadir al carrito (intercepta /cart/add) ──
  var _fetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = (args[0] && args[0].url) || args[0] || '';
    var self = this, esAdd = typeof url === 'string' && /\/cart\/add(\.js)?($|\?)/.test(url);
    var p = (esAdd && regPend) ? regEsperaTope(3000).then(function () { return _fetch.apply(self, args); }) : _fetch.apply(this, args);
    if (esAdd) {
      p.then(function (res) {
        if (res && res.ok) { getCart().then(function () { open(); }); }
        return res;
      }).catch(function () {});
    } else if (typeof url === 'string' && /\/cart\/(change|update|clear)(\.js)?($|\?)/.test(url)) {
      p.then(function (res) {
        if (res && res.ok) getCart().then(function (c) {
          if (root && root.classList.contains('is-open')) render(); else paintRegalo(c, true);
          regPagina(c); setTimeout(function () { regPagina(cache); }, 900);        // el tema repinta la página tras su cambio
        });
        return res;
      }).catch(function () {});
    }
    return p;
  };

  // API pública para que otras secciones (completa-look, packs) abran el cajón
  window.vbCart = { open: function () { getCart().then(open); }, refresh: function () { getCart().then(render); }, close: close };

  function bindDiscount() {
    var form = root.querySelector('[data-vb-disc-form]');
    if (!form) return;
    var toggle = root.querySelector('[data-vb-disc-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        form.hidden = !form.hidden;
        toggle.hidden = !form.hidden ? true : false;
        if (!form.hidden) { var i = form.querySelector('input'); if (i) i.focus(); }
      });
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('[data-vb-disc-input]');
      var msg = root.querySelector('[data-vb-disc-msg]');
      var code = (input.value || '').trim();
      if (!code) return;
      var btn = form.querySelector('button');
      btn.disabled = true;
      fetch('/discount/' + encodeURIComponent(code), { method: 'GET' })
        .then(function () { return getCart(); })
        .then(function () {
          msg.hidden = false;
          msg.className = 'vb-drawer__disc-msg ok';
          msg.textContent = '✓ Código "' + code + '" aplicado · se reflejará en el pago.';
          var co = root.querySelector('[data-vb-checkout]');
          if (co) co.setAttribute('href', '/checkout');
          input.value = '';
          btn.disabled = false;
        })
        .catch(function () {
          msg.hidden = false; msg.className = 'vb-drawer__disc-msg err';
          msg.textContent = 'No se pudo aplicar el código.';
          btn.disabled = false;
        });
    });
  }

  function init() {
    root = document.getElementById('vb-drawer');
    if (root) { getCart().then(function (c) { if (c && c.item_count) { regCabecera(regPrendas(c)); regPagina(c); paintRegalo(c, true); } }).catch(function () {}); bindDiscount(); }
    initRegaloFicha();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
